import styled from "styled-components";

export const Container = styled.div`
  background: #ffffff;
`;

export const ButtonContainerWithoutBackButton = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid #ebebeb;
`;

export const ButtonContainer = styled(ButtonContainerWithoutBackButton)`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;
